import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Container, Flex, Grid } from '@chakra-ui/react';
import { Logo } from '@whitbread-eos/atoms';
import { formatAssetsUrl } from '@whitbread-eos/utils';
import { useEffect, useState } from 'react';
import BookingFlowSteps from '../../BookingFlowSteps';
import { containerLogoStyle, containerWrapperStyles, contentStyles, headerWrapperStyles } from '../HeaderLeisure.style';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HeaderVariantStep(_ref) {
  var _headerInfoData$conte, _headerInfoData$conte2;
  var _ref$currentLang = _ref.currentLang,
    currentLang = _ref$currentLang === void 0 ? 'en' : _ref$currentLang,
    _ref$currentCountry = _ref.currentCountry,
    currentCountry = _ref$currentCountry === void 0 ? 'gb' : _ref$currentCountry,
    headerInfoData = _ref.headerInfoData,
    propsStepProgress = _ref.propsStepProgress,
    hotelBrand = _ref.hotelBrand,
    bb = _ref.bb;
  var isWindowDefined = typeof window !== 'undefined';
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    origin = _useState2[0],
    setOrigin = _useState2[1];
  useEffect(() => {
    setOrigin(window.location.origin);
  }, [isWindowDefined]);
  var getHomePath = isBB => {
    return !isBB ? "".concat(origin, "/").concat(currentCountry, "/").concat(currentLang, "/home.html") : "".concat(origin, "/").concat(currentCountry, "/").concat(currentLang, "/business-booker/home.html");
  };
  return _jsx(Box, _objectSpread(_objectSpread({}, customHeaderWrapperStyles), {}, {
    "data-testid": "common-header-wrapper",
    children: _jsx(Container, _objectSpread(_objectSpread({}, customContainerWrapperStyles), {}, {
      children: _jsxs(Grid, _objectSpread(_objectSpread({}, contentStyles), {}, {
        children: [_jsx(Flex, _objectSpread(_objectSpread({}, customContainerLogoStyle), {}, {
          "data-testid": "logo-container",
          sx: {
            '@media print': {
              display: 'none'
            }
          },
          children: _jsx(Logo, {
            href: getHomePath(bb),
            src: formatAssetsUrl(headerInfoData === null || headerInfoData === void 0 || (_headerInfoData$conte = headerInfoData.content) === null || _headerInfoData$conte === void 0 || (_headerInfoData$conte = _headerInfoData$conte.header) === null || _headerInfoData$conte === void 0 ? void 0 : _headerInfoData$conte.image),
            isHeaderLogo: true,
            variant: currentLang === 'de' && hotelBrand !== 'hub' && hotelBrand !== 'zip' ? 'pi-simple' : hotelBrand,
            transform: "scale(1)"
          })
        })), _jsx(Container, _objectSpread(_objectSpread({}, containerLogoBookingFlow), {}, {
          "data-testid": "logo-container",
          sx: {
            '@media print': {
              mb: 'sm'
            }
          },
          children: _jsx(Logo, {
            src: formatAssetsUrl(headerInfoData === null || headerInfoData === void 0 || (_headerInfoData$conte2 = headerInfoData.content) === null || _headerInfoData$conte2 === void 0 || (_headerInfoData$conte2 = _headerInfoData$conte2.header) === null || _headerInfoData$conte2 === void 0 ? void 0 : _headerInfoData$conte2.image),
            href: getHomePath(bb),
            variant: hotelBrand === 'pi' ? 'pi-icon' : "".concat(hotelBrand, "-simple")
          })
        })), _jsx(BookingFlowSteps, {
          steps: propsStepProgress.steps,
          activeStep: propsStepProgress.activeStep
        })]
      }))
    }))
  }));
}
var customContainerWrapperStyles = _objectSpread(_objectSpread({}, containerWrapperStyles), {}, {
  pl: {
    mobile: 'md',
    md: 'lg',
    lg: 'xl',
    xl: '5xl'
  },
  pr: {
    mobile: 'md',
    md: 'lg',
    lg: 'xl',
    xl: '5xl'
  }
});
var customContainerLogoStyle = _objectSpread(_objectSpread({}, containerLogoStyle), {}, {
  display: {
    mobile: 'none',
    lg: 'flex'
  }
});
var customHeaderWrapperStyles = _objectSpread(_objectSpread({}, headerWrapperStyles), {}, {
  h: {
    mobile: 'var(--chakra-space-5xl)',
    sm: 'var(--chakra-space-7xl)',
    md: 'var(--chakra-space-8xl)'
  }
});
var containerLogoBookingFlow = _objectSpread(_objectSpread({}, containerLogoStyle), {}, {
  display: {
    mobile: 'flex',
    lg: 'none'
  },
  justifyContent: 'flex-start',
  p: 0,
  w: 'auto'
});